<template>
  <div class="form-group">
    <label class="form-label"><strong>{{ headline }}</strong></label>
    <div class="row gutters-xs m-0">
      <div class="col-auto" style="padding: 1px" v-for="color in color_list" :key="color">
        <label class="colorinput">
          <input
            name="color"
            type="checkbox"
            class="colorinput-input"
            :value="color"
            :checked="color === selected_color"
            @input="check_color($event, color)">
          <span :class="[size, 'colorinput-color']" :style="{'background-color': get_color(color)}"></span>
        </label>
      </div>

      <div class="col-auto" style="padding: 1px" v-if="showUnsetOption">
        <label class="custom-control custom-checkbox pl-0">
          <input
            type="checkbox"
            class="custom-control-input"
            name="color_default"
            :checked="'default' === selected_color"
            @input="check_color($event, 'default')" />
          <span :class="[size, 'custom-control-label']">No Color</span>
        </label>
      </div>
    </div>
  </div>
</template>
<script>
import { COLOR_LIST, get_color_rgb } from '@/misc/colors'

export default {
  props: {
    selected_color: { // TODO: value
      type: String,
      default: "default"
    },
    headline: {
      type: String,
      default: "Select a color"
    },
    size: {
      default: 'normal'
    },
    showUnsetOption: {
      default: false
    }
  },
  data() {
    return {
      color_list: COLOR_LIST
    };
  },
  methods: {
    check_color(evt, color) {
      if ( evt.target.checked ) {
        console.log("Emitting color " + color);
        this.$emit("color-select", color);
      } else {
        this.$emit("color-select", 'default');
      }
    },
    get_color(color) {
      return get_color_rgb(color);
    }
  }
};
</script>

<style>
.colorinput-color.mini {
  width: 0.75em;
  height: 0.75em;
}
.colorinput-color.mini::before {
  top: 0.25em;
  left: 0;
  height: 0.75em;
  width: 0.75em;
}
.colorinput-color.small {
  width: 1.25rem;
  height: 1.25rem;
}
.colorinput-color.small::before {
  top: 0;
  left: 0;
  height: 1.25rem;
  width: 1.25rem;
}
</style>
